import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../../styles/ui-alpha';

export const DONATION_MIN_AMOUNT_MINOR = 50;
export const DONATION_MAX_AMOUNT_MINOR = 99_999_999;

export const PRESET_DONATION_DOLLARS = [5, 10, 25, 50] as const;

export const useStyles = makeStyles<Theme>()((theme) => ({
  card: {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, 0.06)}`,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  iconWrap: {
    ...theme.mixins.appIconTintSquare,
    backgroundColor: alpha(theme.palette.error.main, UiAlpha.Tint),
    color: theme.palette.error.main,
  },
  iconSvg: {
    width: 26,
    height: 26,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  presetGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  presetButton: {
    width: '100%',
  },
  amountRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  amountField: {
    flex: '1 1 180px',
    minWidth: 0,
  },
  supportButton: {
    flex: '0 0 auto',
    alignSelf: 'stretch',
  },
}));
